import config from '../config';

const AUTH_LOGOUT_URL = `${config.getAppUrl()}/accounts/logout/`;

export default AUTH_LOGOUT_URL;
